import { FETCH_ORG_ACCESS_DATA_SUCCESS } from "../actions/actionConstants";

const initialState = {
};

export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_ORG_ACCESS_DATA_SUCCESS: {
            return Object.assign({}, state, action.payload);
        }
        default:
            return state;
    }
}
